var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpanded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#405973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8237 8.00001C11.742 7.99985 11.6611 8.01585 11.5855 8.04709C11.51 8.07832 11.4414 8.12417 11.3837 8.18201L5.16571 14.4C5.0564 14.518 4.99704 14.6738 5.00011 14.8346C5.00318 14.9954 5.06844 15.1488 5.18218 15.2625C5.29592 15.3763 5.4493 15.4415 5.61013 15.4446C5.77095 15.4477 5.92672 15.3883 6.04471 15.279L11.8237 9.50001L17.6017 15.278C17.7181 15.395 17.8763 15.4609 18.0413 15.4613C18.2063 15.4616 18.3648 15.3964 18.4817 15.28C18.5987 15.1636 18.6646 15.0055 18.665 14.8404C18.6653 14.6754 18.6001 14.517 18.4837 14.4L12.2657 8.18201C12.2077 8.12393 12.1388 8.07794 12.063 8.0467C11.9871 8.01546 11.9058 7.99959 11.8237 8.00001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_39"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpanded);
export default __webpack_public_path__ + "static/media/expanded.238acf08579fc99c46d7e21fb13a15fe.svg";
export { ForwardRef as ReactComponent };